import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { useGetDashboardPermissionsQuery } from "web_myplann/Api/Calculators/useGetDashboardPermissionsQuery";
import { useIsNoAdvisorQuery } from "web_myplann/Api/Client/useClientQuery";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { DashboardDataSection } from "web_myplann/Dashboard/Components/DashboardDataSection";
import { DashboardPicturedRow } from "web_myplann/Dashboard/Components/DashboardPictureRow";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { DashboardTitleCard } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { FinancialBalance } from "web_myplann/Dashboard/Components/FinancialBalance";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import mortgageImg from "web_myplann/Shared/Assets/mortgage.png";
import travelImg from "web_myplann/Shared/Assets/travel.png";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { device, NavigationTypes } from "web_myplann/Utils/device";

const PageResources = Resources.Dashboard;

const pullToRefreshQueryKeys = [
	TaskKeys.list(),
	[...ActivityKeys.all, "list"],
	FinanceKeys.expense(),
	FinanceKeys.income(),
	FinanceKeys.reporting(),
];

export const DashboardPage = () => {
	const { t } = useResource();
	const { data: permissions, isLoading: isPermissionsLoading } =
		useGetDashboardPermissionsQuery();
	const { data: isNoAdvisor } = useIsNoAdvisorQuery();
	const [isTitleCardEmpty, setIsTitleCardEmpty] = useState(false);
	const [isDataSectionEmpty, setIsDataSectionEmpty] = useState(false);

	const bothSectionsEmpty = isTitleCardEmpty && isDataSectionEmpty;

	useEffect(() => {
		if (!isNoAdvisor) {
			return;
		}
		device.showNavbar(false);
		return () => {
			device.showNavbar(true);
		};
	}, [isNoAdvisor]);

	if (isNoAdvisor) {
		return (
			<MyPlannLayout disableContentPadding disableTopPadding>
				<MissingAdvisor />
			</MyPlannLayout>
		);
	}

	return (
		<MyPlannLayout disableContentPadding disableTopPadding>
			<DashboardTitleCard
				onEmptyChange={setIsTitleCardEmpty}
				pullToRefreshProps={{ queryKeys: pullToRefreshQueryKeys }}
			>
				<Stack pb={2}>
					<DashboardDataSection onEmptyChange={setIsDataSectionEmpty} />
					<Stack pt={bothSectionsEmpty ? 1.6 : 2.4} px={1.6}>
						<FinancialBalance />
					</Stack>
					<Stack px={1.6} pt={1.6}>
						{!isPermissionsLoading && (
							<Typography variant="deprecatedH3">
								{t(PageResources.ImageCard.title)}
							</Typography>
						)}
						{isPermissionsLoading ? (
							<Stack pt={1.2}>
								<DashboardSkeleton height={80} count={2} />
							</Stack>
						) : (
							<Stack
								alignItems="center"
								pt={1.2}
								gap={1.2}
								data-testid="dashboard-image-card"
							>
								<DashboardPicturedRow
									title={t(PageResources.ImageCard.Mortgage.title)}
									description={t(PageResources.ImageCard.Mortgage.description)}
									imageSrc={mortgageImg}
									onClick={() => {
										device.navigationRequest(
											NavigationTypes.MortgageCalculatorScreen,
										);
									}}
									disabled={!permissions?.mortgage}
								/>
								<DashboardPicturedRow
									title={t(PageResources.ImageCard.Travel.title)}
									description={t(PageResources.ImageCard.Travel.description)}
									imageSrc={travelImg}
									onClick={() => {
										device.navigationRequest(
											NavigationTypes.TravelInsuranceCalculatorScreen,
										);
									}}
									disabled={!permissions?.travelInsurance}
								/>
							</Stack>
						)}
					</Stack>
				</Stack>
			</DashboardTitleCard>
		</MyPlannLayout>
	);
};
